import TabsSwitch from './TabsSwitch';

export default TabsSwitch;
